import AbstractCommand from "../../../core/application/AbstractCommand";
import TeaCornerContent from "../model/TeaCornerContent";
import TeaCornerModel from "../model/TeaCornerModel";

export default class TeaCornerContentAvailableCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {TeaCornerModel} coffeeCornerModel 
     */
    constructor(dispatcher, teaCornerModel) {
        super(dispatcher);

        this._teaCornerModel = teaCornerModel;
    }

    execute(evt) {
        const data = evt.params.data;

        const content = data.content;
        const contentPlayer = data.contentPlayer;

        const teaCornerContent = new TeaCornerContent(content, contentPlayer);
        this._teaCornerModel.addContent(teaCornerContent);
    }
}